function loadChatWidget() {
    if (window.chatWidgetLoaded) return;
    window.chatWidgetLoaded = true;

    var cm = document.createElement('script');
    cm.type = 'text/javascript';
    cm.async = true;
    cm.src = 'https://kcsafexvff.chat.digital.ringcentral.com/chat/346d69673caf0a7a3f2356a3/loader.js';
    document.head.appendChild(cm);
  }

  window.addEventListener('scroll', loadChatWidget, { once: true });
  window.addEventListener('mousemove', loadChatWidget, { once: true });
  window.addEventListener('touchstart', loadChatWidget, { once: true });